import React from "react";
import { useTranslation } from "react-i18next";
import { ShowReportIcon } from "../../../assets/iconComponents/ShowReport";
import { themePalette } from "../../../theme";
import { SpanishReportButtonStyled } from "./SpanishReportButton.styles";

interface SpanishReportButtonProps {
  onClick: () => void;
  isDownloading: boolean;
  testId?: string;
}

export const SpanishReportButton: React.FC<SpanishReportButtonProps> = ({
  onClick,
  isDownloading,
  testId = "view-spanish-report",
}) => {
  const { t } = useTranslation();

  return (
    <SpanishReportButtonStyled data-testid={testId} onClick={onClick}>
      <ShowReportIcon color={themePalette.redMedium} />
      {isDownloading
        ? t("spanishReportButton.downloading")
        : t("spanishReportButton.label")}
    </SpanishReportButtonStyled>
  );
};
